import { computed, nextTick, ref, watch } from 'vue';

export const useRaceTablePagination = <T extends any[]>(data: Ref<T>, itemsPerPage: number) => {
  const playersCountToShow = ref(itemsPerPage);
  const triggerUpdate = ref(0);

  // @ts-ignore
  const slicedData = computed((): T => data.value?.slice(0, playersCountToShow.value));
  const isMoreButtonShown = computed(() => data.value?.length > playersCountToShow.value);
  const isLessButtonShown = computed(() => itemsPerPage < playersCountToShow.value);

  const toggleShowMore = () => {
    if (playersCountToShow.value === itemsPerPage) {
      playersCountToShow.value = data.value.length;
    } else {
      playersCountToShow.value = itemsPerPage;
    }
  };

  const updatePlayerCount = (val: number, addToCurrent = false) => {
    if (addToCurrent) {
      playersCountToShow.value += val;
    } else {
      playersCountToShow.value = val;
    }
  };

  const close = () => {
    playersCountToShow.value = itemsPerPage;
  };

  watch(
    () => playersCountToShow.value,
    () => {
      triggerUpdate.value = 1;
      nextTick(() => (triggerUpdate.value = 0));
    }
  );

  return {
    slicedData,
    isMoreButtonShown,
    isLessButtonShown,
    triggerUpdate,
    playersCountToShow,
    toggleShowMore,
    close,
    updatePlayerCount,
  };
};
